var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_182",
    "data-name": "Gruppe 182",
    transform: "translate(-9 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_295",
    "data-name": "Pfad 295",
    d: "M36,12H29V7H19v5H9v2h3V41H36V14h3V12ZM21,9h6v3H21ZM34,39H14V14H34Z",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_296",
    "data-name": "Pfad 296",
    d: "M23,18V35h2V18H23Z",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_297",
    "data-name": "Pfad 297",
    d: "M18,18V35h2V18H18Z",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_298",
    "data-name": "Pfad 298",
    d: "M28,18V35h2V18H28Z",
    fill: "#040506"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Delete_icon.895c2fe9e052fd7f9f5ea0028028a32c.svg";